import ContrastIcon from 'volto-ministerio-publico-federal/components/Icons/Contrast';
import SiteMapIcon from 'volto-ministerio-publico-federal/components/Icons/SiteMap';
import { MPFIconButton } from 'volto-ministerio-publico-federal/components/UI';
import { comPrefixo } from 'volto-ministerio-publico-federal/helpers/Url/subpath';

interface AccessibilityControlsProps {
  a11y: any;
  variant: string;
  /**
   * Quando informado, o atalho para o mapa do site é renderizado como segundo
   * controle, logo após o alto contraste — é assim na barra superior e no
   * menu de opções do mobile. Onde a prop é omitida (dropdown compacto), o
   * mapa aparece como link de texto fora deste componente.
   */
  sitemapLink?: string;
  /**
   * Ordem dos controles de tamanho de texto. O padrão é o da barra superior
   * (A− e depois A+); o menu de opções do mobile inverte, conforme o layout.
   * A troca é feita aqui, e não com `order` no CSS, para a ordem visual e a
   * de tabulação continuarem iguais.
   */
  fontOrder?: 'decrease-first' | 'increase-first';
}
export const AccessibilityControls = ({
  a11y,
  variant,
  sitemapLink,
  fontOrder = 'decrease-first',
}: AccessibilityControlsProps) => {
  const isMobile = variant === 'mobile';
  const btnClass = isMobile
    ? 'mpf-topbar__a11y-button w-full'
    : 'mpf-topbar__a11y-button';
  // No desktop os controles encostam no topo da página; a dica abre para
  // baixo para não nascer fora da janela (AB#11388). No painel mobile há
  // espaço acima e vale o padrão.
  const tooltipPosition = isMobile ? undefined : 'bottom';

  const decrease = (
    <MPFIconButton
      key="decrease"
      variant="unstyled"
      shape="square"
      aria-label="Diminuir tamanho do texto"
      data-tooltip="Diminuir tamanho do texto"
      data-tooltip-position={tooltipPosition}
      onClick={a11y.decreaseFont}
      className={btnClass}
      icon={<span>A−</span>}
    />
  );

  const increase = (
    <MPFIconButton
      key="increase"
      variant="unstyled"
      shape="square"
      aria-label="Aumentar tamanho do texto"
      data-tooltip="Aumentar tamanho do texto"
      data-tooltip-position={tooltipPosition}
      onClick={a11y.increaseFont}
      className={btnClass}
      icon={<span>A+</span>}
    />
  );

  return (
    <>
      <MPFIconButton
        variant="unstyled"
        role="switch"
        shape="square"
        aria-checked={a11y.contrast}
        aria-label={
          a11y.contrast ? 'Desativar alto contraste' : 'Ativar alto contraste'
        }
        data-tooltip={
          a11y.contrast ? 'Desativar alto contraste' : 'Ativar alto contraste'
        }
        data-tooltip-position={tooltipPosition}
        onClick={a11y.toggleContrast}
        className={`${btnClass}${
          a11y.contrast ? ' mpf-topbar__a11y-button--active' : ''
        }`}
        icon={<ContrastIcon className="mpf-topbar__a11y-icon" />}
      />

      {sitemapLink && (
        <MPFIconButton
          as="a"
          shape="square"
          href={comPrefixo(sitemapLink)}
          variant="unstyled"
          aria-label="Mapa do site"
          data-tooltip="Mapa do site"
          data-tooltip-position={tooltipPosition}
          className={btnClass}
          icon={<SiteMapIcon className="mpf-topbar__a11y-icon" />}
        />
      )}

      {fontOrder === 'increase-first'
        ? [increase, decrease]
        : [decrease, increase]}
    </>
  );
};
